import Gallery from "@bottlebooks/bottlebooks-site-base/src/components/Gallery/Gallery.next";
import Section from "@bottlebooks/bottlebooks-site-base/src/components/Section/Section";
import { Container } from "@bottlebooks/gatsby-design-system";
import React from "react";

const publicIds = [
  "portwinefest.com/16_Port_Wine_Fest_Website_Pebble_Beach.JPG",
  "portwinefest.com/17_Port_Wine_Fest_Website_Pebble_Beach.JPG",
  "portwinefest.com/18_Port_Wine_Fest_Website_Pebble_Beach.JPG",
  "portwinefest.com/19_Port_Wine_Fest_Website_Pebble_Beach.JPG",
  "portwinefest.com/20_Port_Wine_Fest_Website_Pebble_Beach.JPG",
  "portwinefest.com/21_Port_Wine_Fest_Website_Pebble_Beach.JPG",
  "portwinefest.com/22_Port_Wine_Fest_Website_Pebble_Beach.JPG",
  "portwinefest.com/23_Port_Wine_Fest_Website_Pebble_Beach.JPG",
  "portwinefest.com/24_Port_Wine_Fest_Website_Pebble_Beach.JPG",
  "portwinefest.com/25_Port_Wine_Fest_Website_Pebble_Beach.JPG",
  "portwinefest.com/26_Port_Wine_Fest_Website_Pebble_Beach.JPG",
  "portwinefest.com/27_Port_Wine_Fest_Website_Pebble_Beach.JPG",
  "portwinefest.com/28_Port_Wine_Fest_Website_Pebble_Beach.JPG",
  "portwinefest.com/29_Port_Wine_Fest_Website_Pebble_Beach.JPG",
  "portwinefest.com/30_Port_Wine_Fest_Website_Pebble_Beach.JPG",
];

const images = publicIds.map((id) => ({
  sourceUrl: `//res.cloudinary.com/bottlebooks/image/upload/${id}`,
  // Thumbnail
  image: {
    src: `https://res.cloudinary.com/bottlebooks/image/upload/c_fill,w_360,h_360/${id}`,
    sizes: "(max-width: 360px) 100vw, 360px",
    width: null,
    height: null,
    aspectRatio: 1,
  },
  fullPreview: {
    src: `https://res.cloudinary.com/bottlebooks/image/upload/w_360,h_360/${id}`,
  },
  full: {
    src: `https://res.cloudinary.com/bottlebooks/image/upload/w_1920/${id}`,
  },
}));

export default function PortWineFestImageGalleryPebbleBeach() {
  return (
    <Container>
      <Section
        title="Gallery"
        sx={{
          paddingY: 3,
          margin: "auto",
          position: "relative",
          width: "100%",
          paddingBottom: "56.25%",
        }}
      >
        <Gallery data={images} />
      </Section>
    </Container>
  );
}
